// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#chartPeriodSelection{\r\n  width: 100%;\r\n  text-align: center;\r\n  align: center;\r\n  margin: 3 3 3 3;\r\n}\r\n.periodButtons {\r\n  text-align:center;\r\n}\r\n.periodbutton{\r\n  margin:2px;\r\n}\r\n.zerobasecheckbox{\r\n  flow:left;\r\n  text-align:left;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
